import Site2 from '@/shared/app/model/templating/Site2';

export const defaultSite: Site2 = {
  pages: [
    {
      templateGetter: () => {
        return {
          component: 'Mock',
          config: {
            text: '1001 Repas\nRestauration collective et responsable',
            background: '#9BCB6C',
          },
        };
      },
    },
  ],
};
